import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { GlobalContext } from "../../../../Context/GlobalContext";

import HtmlEditor from "./HtmlEditorComponents/HtmlEditor";
import CreateNewBanner from "./CreateNewBanner";
import BannerLibrary from "./BannerLibrary";

const ROUTES = {
  BANNER_LIBRARY: "/inventory/banner",
  CREATE_BANNER: "/inventory/banner/create-new-banner",
  HTML_EDITOR: "/inventory/banner/html-editor",
};

function Banner() {
  const navigate = useNavigate();
  const location = useLocation();

  const { setGeneratedHTML } = useContext(GlobalContext);

  const normalizePath = (path = "") => path.toLowerCase().replace(/\/+$/, "");

  const isActive = (route) =>
    normalizePath(location.pathname) === normalizePath(route);

  const tabStyle = (route) => ({
    borderBottom: isActive(route)
      ? "3px solid #00c47d"
      : "3px solid transparent",

    color: isActive(route) ? "#00c47d" : "black",

    borderRadius: "0px",
  });

  return (
    <>
      <div className="d-flex flex-column justify-content-start align-items-start mx-4 flex h-screen flex-col items-start overflow-hidden px-6 py-6 montserrat-font-1">
        <div className="flex w-full flex-col items-start gap-0 montserrat-font-1">

          <div className="mb-1 flex w-full justify-between">
            <div className="flex flex-col">
              <h2 className="CreateCampaign text-xl font-semibold montserrat-font-1">
                Banner Management
              </h2>

              <p className="text-gray-500 montserrat-font-2">
                Create reusable banner templates that save time and ensure
                consistency
              </p>
            </div>
          </div>

          {/* =================================================
              TABS
          ================================================= */}

          <div className="flex w-full gap-3 border-b pb-0">
            {/* Banner Library */}

            <button
              type="button"
              className="btn border-none px-3 py-2 fw-normal montserrat-font-1"
              style={tabStyle(ROUTES.BANNER_LIBRARY)}
              onClick={() => {
                navigate(ROUTES.BANNER_LIBRARY);
              }}
            >
              Banner Library
            </button>

            {/* Create Banner */}

            <button
              type="button"
              className="btn border-none px-3 py-2 fw-normal montserrat-font-1"
              style={tabStyle(ROUTES.CREATE_BANNER)}
              onClick={() => {
                setGeneratedHTML("");
                navigate(ROUTES.CREATE_BANNER);
              }}
            >
              Create Banner
            </button>
          </div>

          {/* =================================================
              CONTENT
          ================================================= */}

          <div className="mt-2 w-full montserrat-font-1">

            {isActive(ROUTES.HTML_EDITOR) && <HtmlEditor />}

            {isActive(ROUTES.BANNER_LIBRARY) && <BannerLibrary />}

            {isActive(ROUTES.CREATE_BANNER) && (
              <div
                style={{
                  width: "55vw",
                  height: "100%",
                }}
              >
                <CreateNewBanner />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Banner;
